<template>
<div>
    <v-app-bar v-if="loggedIn && acceptedEula" elevate-on-scroll>
        <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>
        <router-link to="/landing">
            <v-toolbar-title>
                <!-- <v-img contain width="50" src="../../../../public/account_exec_circle_logo_extra_blue.png" ></v-img>      -->
                <v-img contain width="80" src="../../../../public/logo_with_tm.png" ></v-img>
            </v-toolbar-title>
        </router-link>

        <v-spacer></v-spacer>

        <v-btn icon style="display:none;">
            <v-icon>mdi-bell</v-icon>
        </v-btn>
            <v-btn icon @click="toProfile">
                <v-icon>mdi-account</v-icon>
            </v-btn>
            <div class="text cursor-pointer" @click="toProfile">
                {{ userName }}
            </div>

    </v-app-bar>

    <v-navigation-drawer
        v-model="drawer"
        absolute
        temporary
      >
      <v-list-item>
        <v-list-item-content>
            <v-list-item-title class="text-2xl">
                <router-link to="/landing">
                    AccountExec

                </router-link>
            </v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list
          nav
        >
            <!-- Add more items to the menu here -->
            <DrawerItemLink to="/" icon="mdi-home" title="Dashboard" />
            <DrawerItemLink to="/profile" icon="mdi-account" title="Profile" />
            <v-divider></v-divider>
            <DrawerItemLink to="/logout" icon="mdi-logout" title="Logout" />

        </v-list>
      </v-navigation-drawer>
</div>
</template>


<script>
import DrawerItemLink from './DrawerItemLink.vue';
export default {
    name: "UniversalNav",
    data() {
        return {
            group: null,
            drawer: false,
        };
    },
    methods: {
        toProfile () {
            if (this.$route.name !== 'profile') {
                this.$router.push('/profile')
            }
        }
    },
    computed: {
        loggedIn () {
            return this.$store.getters.isLoggedIn
        },
        acceptedEula () {
            return this.$store.getters.hasAcceptedEula
        },
        userName () {
            return this.$store.getters.userName
        }
    },
    components: { DrawerItemLink, DrawerItemLink }
}
</script>
